/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import type { GestureResponderEvent } from 'react-native';
import { StyleSheet } from 'react-native';
import { TextLink, theme } from '@sweetgreen/garnish';

export type AccountMenuSecondaryItemProps = {
  readonly testID: string;
  readonly label: string;
  readonly onPress: (event: GestureResponderEvent) => void;
  readonly active?: boolean;
  readonly disabled?: boolean;
};

export const AccountMenuSecondaryItem = ({
  testID,
  label,
  onPress,
}: AccountMenuSecondaryItemProps) => {
  return (
    <TextLink
      testID={testID}
      style={styles.textLink}
      underline={false}
      onPress={onPress}
    >
      {label}
    </TextLink>
  );
};

const styles = StyleSheet.create({
  textLink: {
    color: theme.colors.DARK_KALE,
    marginVertical: theme.spacing.small,
  },
});
